import { render, staticRenderFns } from "./MediaController.vue?vue&type=template&id=5bce7096&scoped=true&"
import script from "./MediaController.vue?vue&type=script&lang=js&"
export * from "./MediaController.vue?vue&type=script&lang=js&"
import style0 from "./MediaController.vue?vue&type=style&index=0&id=5bce7096&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bce7096",
  null
  
)

export default component.exports